import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { baseParams } from '@/business/apiTreatment/request/queryParamsUtils';
import ActionsService from '@/services/services/actions.service';
import CrudModule from '@/store/crudModule';

const makeCreateParams = ({ rootGetters, item }) => {
  const newItem = baseParams({ rootGetters, item });

  if (!newItem.deadline_datetime) delete newItem.deadline_datetime;
  newItem.action_plan_id = rootGetters['actionplans/current'].id;
  newItem.persons_in_charge = newItem.staffs_in_charge_id.map((id) => {
    return {
      staff_id: id,
    };
  });
  delete newItem.staffs_in_charge_id;
  return newItem;
};

function formatUpdateParams(item) {
  const newItem = { ...item };
  if (!newItem.deadline_datetime) delete newItem.deadline_datetime;
  newItem.persons_in_charge = newItem.staffs_in_charge_id
    ? newItem.staffs_in_charge_id.map((id) => {
        return {
          staff_id: id,
        };
      })
    : [];
  delete newItem.staffs_in_charge_id;
  return newItem;
}

const makeUpdateParams = ({ item, rootGetters }) => {
  const newItem = baseParams({ rootGetters, item });

  return { newItem: formatUpdateParams(newItem) };
};

const setStatuWhenUserExchangeCreated = ({ commit, getters }) => {
  if (getters.current.current_action_status_type_id === 1) {
    commit('UPDATE_CURRENT', {
      ...getters.current,
      current_action_status_type_id: 2,
      current_act_status_type_name: 'Lancée',
    });
  }
};
export default new CrudModule({
  serviceAPI: ActionsService,
  makeQueryParams: makeListRequest({}),
  makeCreateParams,
  makeUpdateParams,
  customActions: {
    setStatuWhenUserExchangeCreated,
  },
});

export { formatUpdateParams };
